import { ref } from 'vue';
import useAppFetch from '@/api/utils/useAppFetch';
import type { EmptyObject } from '@/types';
import type { AsyncStateReturn } from '@/components/common/ElAsyncLoader/elAsyncLoader';
import { useAsyncState } from '@vueuse/core';
import type { LoggerErrorPayload } from '@/composables/useAppLogger/appLogger.types';
import { SYSTEM_APP_ERROR_LOG_URI } from '@/api/sirta/sirtaEndpoints';

export default function useAppErrorLogApi() {
  const payload = ref<LoggerErrorPayload>();
  const appFetch = useAppFetch<EmptyObject>(SYSTEM_APP_ERROR_LOG_URI, { immediate: false });

  const {
    execute,
    apiResponse,
  } = appFetch;
  appFetch.post(payload).json();

  function postError(errorPayload: LoggerErrorPayload): AsyncStateReturn<EmptyObject> {
    return useAsyncState(async () => {
      payload.value = errorPayload;
      await execute();
      return apiResponse;
    }, apiResponse, { immediate: false });
  }

  return {
    postError,
  };
}
